import { Component, Input, HostBinding } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdDefaults } from '../ad-default';


@Component({
    selector: 'progresslist',
    templateUrl: './progress.component.html',
    styleUrls: ['./progress.component.scss']
})
export class ProgressComponent extends AdDefaults{


    @Input() info : any;
    @HostBinding('className') className = '';
    @Input() swiperConfig : any;

    _images : any = [];

    constructor( 
        protected gs : GeneralService
    ){
        super(gs);
        
    }
}